import { onMount, onDestroy } from "@/modules/_";
import hey from "@lib/hey";

export default function (element: HTMLVideoElement, dataset: DOMStringMap) {
  const playVideo = () => {
    // console.log("playVideo");
    if (element.paused || element.ended) {
      element.play();
    }
  };

  hey.on("PRELOADER_COMPLETE", () => {
    playVideo();
  });

  onMount(() => {
    playVideo();
  });

  onDestroy(() => {
    element.pause();
  });
}
